import { useCallback, useState, useContext, useEffect } from "react";
import { getOrganizationWfh,deleteOrganizationWfh,addOrganizationWfh } from "../ApplyLeave/Wfh/WfhSerevice";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import { getRawSystemAlertsArray } from "../../../Routes/AuthGard/usePermissions";

const OrgWfhSetting = () => {
  const [columns, setColumns] = useState(["Wfh Type", "Desc", "Frequency", "Credit Count", "Expiry Frequency", "Expiry Count", "Accumulation Limit", "Advance Work from home Window", "Past Work from homeWindow", "Advance Notice"]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [orgWfhList,setOrgWfhList] = useState([])
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [orgWfhId, setOrgWfhId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  let SystemAlerts = getRawSystemAlertsArray();
  const [errors, setErrors] = useState({});


  useEffect(() => {
    GetOrgWfh();
  }, []);


  const validateOrgWfh = (data, index) => {
    const newErrors = {};

    newErrors[`${index}-WFHType`] =
      !data.WFHType || data.WFHType.trim() === ""
        ? "WFH Type is required"
        : undefined;

    newErrors[`${index}-Desc`] =
      !data.Desc || data.Desc.trim() === ""
        ? "Desc is required"
        : undefined;

    newErrors[`${index}-Frequency`] =
      !data.Frequency || data.Frequency.trim() === ""
        ? "Frequency is required"
        : undefined;

    newErrors[`${index}-CreditCount`] =
      !data.CreditCount || data.CreditCount.trim() === ""
        ? "CreditCount is required"
        : undefined;

    newErrors[`${index}-ExpiryFrequency`] =
      !data.ExpiryFrequency || data.ExpiryFrequency.trim() === ""
        ? "CreditCount is required"
        : undefined;

    newErrors[`${index}-ExpiryCount`] =
      !data.ExpiryCount || data.ExpiryCount.trim() === ""
        ? "ExpiryCount is required"
        : undefined;

    newErrors[`${index}-AccumulationLimit`] =
      !data.AccumulationLimit || data.AccumulationLimit.trim() === ""
        ? "AccumulationLimit is required"
        : undefined;

    newErrors[`${index}-AdvanceWFHWindow`] =
      !data.AdvanceWFHWindow || data.AdvanceWFHWindow.trim() === ""
        ? "AdvanceWFHWindow is required"
        : undefined;
    newErrors[`${index}-PastWFHWindow`] =
      !data.PastWFHWindow || data.PastWFHWindow.trim() === ""
        ? "PastWFHWindow is required"
        : undefined;
    newErrors[`${index}-AdvanceNotice`] =
      !data.AdvanceNotice || data.AdvanceNotice.trim() === ""
        ? "AdvanceNotice is required"
        : undefined;
    

    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };
  async function GetOrgWfh() {
    setIsloading(true);
    try {
      let responce = await getOrganizationWfh({});
      setOrgWfhList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgWfhList([
      ...orgWfhList,
      { WFHType: "", Desc: "", Frequency: "", CreditCount: "", ExpiryFrequency: "", ExpiryCount: "", AccumulationLimit: "", AdvanceWFHWindow: "", PastWFHWindow: "", AdvanceNotice: "" },
    ]);
    setEditIndex(orgWfhList.length); 
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

  const [data, setData] = useState({
    WFHType: "",
    Desc: "",
    Frequency: "",
    CreditCount: "",
    ExpiryFrequency: "",
    ExpiryCount: "",
    AccumulationLimit: "",
    AdvanceWFHWindow: "",
    PastWFHWindow: "",
    AdvanceNotice: "",
  });
  const handleChange = (rowIdx, colName) => (e) => {
  const { value } = e.target;
  setOrgWfhList(prevList => {
    const newList = prevList.map((item, idx) =>
      idx === rowIdx ? { ...item, [colName]: value } : item
    );
    return newList;
  });
  setData(prev => ({ ...prev, [colName]: value }));
  validateOrgWfh({ ...orgWfhList[rowIdx], [colName]: value }, rowIdx);
};

  const cancelOrgWfh = () => {
  GetOrgWfh();
  setOrgWfhList(prevList => {
    setEditIndex(null);
    const len = prevList.length;
    if (len === 0) return prevList;

    const lastItem = prevList[len - 1];
    const isEmpty = lastItem &&
      !lastItem.WFHType &&
      !lastItem.Desc &&
      !lastItem.Frequency &&
      !lastItem.CreditCount &&
      !lastItem.ExpiryFrequency &&
      !lastItem.ExpiryCount &&
      !lastItem.AccumulationLimit &&
      !lastItem.AdvanceWFHWindow &&
      !lastItem.PastWFHWindow &&
      !lastItem.AdvanceNotice;
    if (isEmpty) {
      return prevList.slice(0, -1);
    }
    return prevList;
  });
}

  async function addOrgWfh(index, data) { 
    const body = {
    Id: data?.Id || 0,
    OrgId: userDetails?.OrgId,
    WFHTypeId: data.WFHTypeId || 0,
    WFHType: data.WFHType,
    Desc: data.Desc,
    Frequency: data.Frequency,
    CreditCount: parseInt(data.CreditCount, 10),
    ExpiryFrequency: data.ExpiryFrequency,
    ExpiryCount: parseInt(data.ExpiryCount, 10),
    AccumulationLimit: parseInt(data.AccumulationLimit, 10),
    AdvanceWFHWindow: parseInt(data.AdvanceWFHWindow, 10),
    PastWFHWindow: parseInt(data.PastWFHWindow, 10),
    AdvanceNotice: parseInt(data.AdvanceNotice, 10),
    };
    try {
      await addOrganizationWfh(body);
      if (orgWfhId) {
        GetMasterSystemAlertList("Award_Updated", 0);
      } else {
        GetMasterSystemAlertList("Award_Added", 0);
      }
      setOrgWfhList([]);
      GetOrgWfh();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handleWfhlstDelete = (Id) => {
    setOrgWfhId(Id);
  };

   async function DeleteOrgWfh() { 
      setIsloading(true);
      if (orgWfhId) {
        let body = {
          Id: orgWfhId,
        };
        try {
          let orgWfhDeleteList = await deleteOrganizationWfh(body);
          if (orgWfhDeleteList) {
            GetMasterSystemAlertList("Wfh is deleted!", 0);
            setIsloading(false);
            GetOrgWfh();
          }
        } catch (error) {
          toster.current.error(ERROR_LIST.DefaultError);
        }
      }
    }
  const GetMasterSystemAlertList = useCallback((message, type) => {
  SystemAlerts?.forEach((msg) => {
    if (msg?.Name === message && type === 0) {
      toster.current.success(msg?.Desc);
    } else if (msg?.Name === message && type === 1) {
      toster.current.info(msg?.Desc);
    } else if (msg?.Name === message && type === 2) {
      toster.current.error(msg?.Desc);
    }
  });
}, [SystemAlerts]);

  let SearchValue = "";
  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };
  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgWfhList.filter((orgWfh) =>
        orgWfh.WFHType?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgWfhList(filteredList);
      } else {
        GetOrgWfh();
      }
    }, 800),
    [orgWfhList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
        </div>
        <div className="title-text">
          <h3>Work from home types ({orgWfhList?.length})</h3>
          <div className="d-flex">
          <InputText
            name="requestTitle"
            className="form-control search-grpname me-2"
            onChange={handleInputChange}
            placeholder="Search"
          />
          {!editIndex && (
            <button
              className="addaward-btn"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-bs-original-title=""
              fdprocessedid="izng1j"
              onClick={handleAddRow}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
              </svg>
              Work from home
            </button>
          )}
          </div>
        </div>
        <div className="col-md-12 column">
          <div className="table-responsive">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgWfhList?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          value={data.WFHType}
                          onChange={handleChange(index, "WFHType")}
                          placeholder="Work from home Type"
                          className={`form-control ${errors[`${index}-WFHType`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-WFHType`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-WFHType`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          value={data.Desc}
                          onChange={handleChange(index, "Desc")}
                          placeholder="Desc"
                          className={`form-control ${errors[`${index}-Desc`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-Desc`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Desc`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          value={data.Frequency}
                          onChange={handleChange(index, "Frequency")}
                          placeholder="Frequency"
                          className={`form-control ${errors[`${index}-Frequency`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-Frequency`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Frequency`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.CreditCount}
                          onChange={handleChange(index, "CreditCount")}
                          placeholder="Credit Count"
                          className={`form-control ${errors[`${index}-CreditCount`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-CreditCount`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-CreditCount`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          value={data.ExpiryFrequency}
                          onChange={handleChange(index, "ExpiryFrequency")}
                          placeholder="Expiry Frequency"
                          className={`form-control ${errors[`${index}-ExpiryFrequency`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-ExpiryFrequency`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-ExpiryFrequency`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.ExpiryCount}
                          onChange={handleChange(index, "ExpiryCount")}
                          placeholder="Expiry Count"
                          className={`form-control ${errors[`${index}-ExpiryCount`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-ExpiryCount`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-ExpiryCount`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.AccumulationLimit}
                          onChange={handleChange(index, "AccumulationLimit")}
                          placeholder="Accumulation Limit"
                          className={`form-control ${errors[`${index}-AccumulationLimit`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-AccumulationLimit`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-AccumulationLimit`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.AdvanceWFHWindow}
                          onChange={handleChange(index, "AdvanceWFHWindow")}
                          placeholder="Advance WFH Window"
                          className={`form-control ${errors[`${index}-AdvanceWFHWindow`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-AdvanceWFHWindow`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-AdvanceWFHWindow`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.PastWFHWindow}
                          onChange={handleChange(index, "PastWFHWindow")}
                          placeholder="Past WFH Window"
                          className={`form-control ${errors[`${index}-PastWFHWindow`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-PastWFHWindow`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-PastWFHWindow`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="number"
                          value={data.AdvanceNotice}
                          onChange={handleChange(index, "AdvanceNotice")}
                          placeholder="Advance Notice"
                          className={`form-control ${errors[`${index}-AdvanceNotice`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-AdvanceNotice`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-AdvanceNotice`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                            onClick={() => {
                            addOrgWfh(index, data);
                            setEditIndex(null);
                            
                           }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.WFHType}</td>
                      <td>{data?.Desc}</td>
                      <td>{data?.Frequency}</td>
                      <td>{data?.CreditCount}</td>
                      <td>{data?.ExpiryFrequency}</td>
                      <td>{data?.ExpiryCount}</td>
                      <td>{data?.AccumulationLimit}</td>
                      <td>{data?.AdvanceWFHWindow}</td>
                      <td>{data?.PastWFHWindow}</td>
                      <td>{data?.AdvanceNotice}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-wfh"
                          onClick={() => {
                            handleWfhlstDelete(data?.Id);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
        <div className="modal fade " id="delete-org-wfh">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Work from home?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                 className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgWfh()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgWfhSetting;
